import {Injectable} from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MessageService {

    private _message : Subject<string>  = new Subject<string>();
    private data = {};

    sendMessage(message: string) {
        this._message.next(message);
    }

    getMessage(): Observable<any> {
        return this._message.asObservable();
    }

    setItem(key: string, value): void {
        if (this.data[key]) {
            console.warn('Message with key "' + key + '" already exists');
        }
        this.data[key] = JSON.stringify(value);
    }

    getItem(key: string, deleteKey = false): any {
        if (this.data[key]) {
            const data = JSON.parse(this.data[key]);
            if (deleteKey) delete this.data[key];
            return data;
        } else {
            console.warn('Message with key "' + key + '" does not exist');
            return null;
        }
    }
}
